import { render, staticRenderFns } from "./PlanRate.vue?vue&type=template&id=7051afd9&"
import script from "./PlanRate.vue?vue&type=script&lang=js&"
export * from "./PlanRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports